import '../../src/fonts.scss'

const drawerWidth = '19vw';

export const documentStyles = theme => ({
  expansionPanel:{
    width: '100%',
    backgroundColor: theme.palette.darkBlue,
    color: theme.palette.white,
    boxShadow: '0 2px 6px 0 rgba(16, 119, 255,  0.7)',
  },
  expandIcon:{
    color: theme.palette.white
  },
  fullWidth:{
    width: '100%',
  },
  tableKey: {
    pointerEvents: 'none',
    backgroundColor: theme.palette.brownishGray
  },
  formField: {
    paddingTop: 0,
    marginTop: 0,
    marginBottom: 0,
  },
  tableHeader: {
    paddingTop: 0,
    marginTop: 0,
    marginBottom: 0,
    pointerEvents: 'none',
  },
  headerField: {
    backgroundColor: theme.palette.coolGray2,
    fontWeight: 'bold'
  },
  table: {
    width: '100%',
    padding: '0vh 1vw'
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: '16%',
      flexShrink: 0,
    },
  },
  thumbnailContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '64px',
    backgroundColor: theme.palette.white,
    justifyContent: 'center',
    borderRadius: '5.3px'
  },
  formSubmitContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  pageAction: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '5vh',
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: '17%',
    },
    backgroundColor: theme.palette.red
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  drawerPaper: {
    border: 0,
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
    },
    [theme.breakpoints.up('md')]: {
      width: '8%',
    },
    backgroundColor: theme.palette.darkBlue
  },
  documentDrawer: {
    border: 0,
    backgroundColor: theme.palette.darkBlue,
    width: '100%',
    height: '270px'
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.lighGray
  },
  sidebarFlex: {
    height: 'calc(100vh - 64px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  columnFlex: {
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    color: theme.palette.white,
    fontSize: '16px',
    fontFamily: 'Roboto',
    backgroundColor: theme.palette.blue,

    [theme.breakpoints.between('sm', 'md')]: {
      width: '20.6vw',
    },
    [theme.breakpoints.up('md')]: {
      width: '11.6vw',
    },
    marginBottom: '2vh',
    marginLeft: '1vw',
    height: '44px'
  },

  submitButton: {
    color: theme.palette.white,
    fontSize: '16px',
    fontFamily: 'Roboto',
    backgroundColor: theme.palette.blue,

    [theme.breakpoints.between('sm', 'md')]: {
      width: '20.6vw',
    },
    [theme.breakpoints.up('md')]: {
      width: '11.6vw',
    },
    marginBottom: '2vh',
    marginLeft: '1vw',
    height: '44px',
    marginTop: '4vh'
  },
  cancelButton: {
    color: theme.palette.coolGray,
    fontSize: '16px',
    fontFamily: 'Roboto',
    backgroundColor: theme.palette.dark,

    [theme.breakpoints.between('sm', 'md')]: {
      width: '20.6vw',
    },
    [theme.breakpoints.up('md')]: {
      width: '11.6vw',
    },
    marginBottom: '2vh',
    marginLeft: '1vw',
    height: '44px',
    elevation: 0
  },
  sidebarFooter: {
    justifyContent: 'space-between',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    color: theme.palette.white,
    fontSize: '12px'
  },
  outerLoader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px'
  },
  progress: {
    color: theme.palette.red,
  },
  images: {
    width: '100%',
    transformOrigin: '0 0'
  },
  thumbnails: {
    height: 'auto',
    width: '50px',
    maxHeight: '58px'
  },
  imageName: {
    fontSize: '10px',
    color: theme.palette.white,
    textAlign: 'center'
  },
  imageDiv: {
    width: '52%',
    fontSize: '18px',
    height: '100vh',

  },
  formDiv: {
    width: '40%',
    backgroundColor: theme.palette.dark,
    display: 'flex',
    flexDirection: 'column'
  },
  activeThumbnail: {
    height: '64px',
    width: '50px',
    border: '4px solid #9097a2',
    borderRadius: '5.3px'
  },
  docHeader: {
    color: theme.palette.white,
    fontSize: '18px'
  },
  navbarContainer: {
  },
  zoomContainer: {
    position: 'fixed',
    top: '50%',
    right: '12%',
    width: '46px',
    height: '120px',
    backgroundColor: 'rgba(62, 70, 78, 0.6)',
    opacity: '0.9',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center'
  },
  pageNo: {
    position: 'absolute',
    top: '5%',
    right: '10%',
    width: '40px',
    height: '20px',
    fontSize: '10px',
    backgroundColor: 'rgba(62, 70, 78, 0.6)',
    opacity: '0.9',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: theme.palette.white
  },
  dropDownIcon: {
    color: theme.palette.coolGray2,
    position: 'absolute'
  },
  svg: {
    cursor: 'pointer'
  },
  thumbnailIcons: {
    position: 'absolute',
    top: '50%',
    left: '33%'

  },
  closeIcon: {
    display: 'flex',
    flexDirection: 'row-reverse',
    color: theme.palette.coolGray
  },
  loading: {
    top: '40%',
    right: '45%',
    position: 'fixed'
  },
  imageContainer: {
    height: '100vh',
    width: 'inherit',
    position: 'fixed',
    backgroundColor: theme.palette.white
  },
  loaderDiv: {
    backgroundColor: theme.palette.dark,
    height: '100%'
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1vw',
  },
  formStyle: {
    height: '100%'
  },
  navIcons: {
    marginRight: '2vw',
    cursor: 'pointer'
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important',
    borderRadius: '4px',
    border: `solid 1px ${theme.palette.battleShipGray}`
  }
});

export const drawerStyles = theme => ({
  documentDrawer: {
    border: 0,
    backgroundColor: theme.palette.darkBlue,
    width: '100%',
    height: '280px',
  },
  closeIcon: {
    display: 'flex',
    flexDirection: 'row-reverse',
    color: theme.palette.coolGray
  },
  drawerContainer: {
    fontSize: '15px',
    color: theme.palette.coolGray,
  },
  docPreview: {
    maxHeight: '98px',
    width: '80px',
    borderRadius: '8px',
    cursor: 'pointer'
  },
  imgCont: {
    height: '98px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: theme.palette.white,
    borderRadius: '8px',
  },
  imageContainer: {
    display: 'flex',
    margin: '4vh 0vw',
    overflowX: 'hidden'
  },
  docDetails: {
    width: '80px',
    marginRight: '2vw',
  },
  deleteIcon: {
    marginTop: '-3vh',
    marginRight: '7px',
    cursor: 'pointer'
  },
  svg: {
    cursor: 'pointer',
    marginRight: '2vw'
  },

})

